export default __webpack_public_path__ + "static/media/F8.ab59aa7f.png";